export class BaseFormController {
    constructor(passthroughService, metaService, contactService, dataService, leadidService) {
        this.metaService = metaService;
        this.passthroughService = passthroughService;
        this.contactService = contactService;
        this.dataService = dataService;
        this.leadidService = leadidService;


        // setup wizard flow.
        this.step = 0;
        // override in your constructor
        this.steps = [];
        this.extraFields = {};
        this.hasExtraStep = false;
    }

    $onInit() {
        // setup data models for template binding.
        this.updateSteps();
        this.contactModel = this.contactService.newModel(this.contact);
        this.dataModel = this.dataService.newModel(this.data);
        this.metaModel = this.metaService.newModel(this.meta);
        this.passthroughModel = this.passthroughService.newModel(this.passthrough);
        this.formType = this.formType || 'short';
        this.submitButtonCopy = this.submitButtonCopy || 'Get Quotes';
        this.doneCopy = this.doneCopy || this.metaService.$sce.trustAsHtml('<p>Your information has been submitted, expect a response in the next few days.</p>');
    }

    updateSteps() {
        this.hasExtraStep = (this.extraFields) ? Object.keys(this.extraFields).length !== 0 : false;
        if (this.hasExtraStep) {this.steps.push({name: 'Extra data', formName: 'formStep[2]', formType: null })}
        this.steps.push({name: 'Done', formName: 'done', formType: null });
    }

    getNextStep() {
        // do not overstep.
        if (this.step >= this.steps.length - 1) return this.step;
        // find next step for formType.
        for (var stepTo = parseInt(this.step)+1; stepTo < this.steps.length; stepTo++) {
            // advance only if formType is not set on step or formType matches for step.
            if (!this.steps[stepTo].formType || this.steps[stepTo].formType.indexOf(this.formType) != -1) {
                return stepTo;
            }
        }
        return this.step;
    }

    next(form) {
        this.leadidService.init();
        this.step = this.getNextStep();
    }

    getPreviousStep() {
        // do not overstep.
        if (this.step <= 0)  return this.step;
        // find next step for formType.
        for (var stepTo = this.step-1; stepTo >= 0; stepTo--) {
            // advance only if formType matches.
            if (!this.steps[stepTo].formType || this.steps[stepTo].formType.indexOf(this.formType) != -1) {
                return stepTo;
            }
        }
        return this.step;
    }

    back() {
        this.leadidService.init();
        this.step = this.getPreviousStep();
    }

    serialize() {
        // required fields
        this.submission = {
            contact: this.contactModel.serialize(),
            data: this.dataModel.serialize(),
        };

        // optional fields
        let meta = this.metaModel.serialize();
        if (meta) { this.submission.meta = meta; }
        let passthrough = this.passthroughModel.serialize();
        if (passthrough) { this.submission.passthrough = passthrough; }
    }

    getErrors(obj, objKey=null) {
        let _errors = [];
        Object.keys(obj).forEach((key) => {
            if (obj[key].constructor === String || obj[key].constructor === Number) {
                let _o = {};
                _o[objKey] = obj[key];
                _errors.push(_o);
            } else {
                _errors = _errors.concat(this.getErrors(obj[key], key));
            }
        });
        return _errors;
    }

    handleThen(response){
        // it seems the reponse has different structures depending on status.
        if (response.data.errors) {
            if (response.data.errors.vertical) {
                console.log('TODO: handle vertical errors, you can trigger this with a bad token.')
                response.data.errors.vertical.forEach(error => this.errors.push(error));
            }
            if (response.data.errors.data) {
                console.log('TODO: handle data errors, you can trigger this by submitting bad data.')
                // map these to form fields.. The keys need to be mapped to out input[names].                     
                // var keys = Object.keys(response.data.errors.data);
                // keys.forEach((key) => {
                //     this.$scope.contactForm[key].$setValidity('server', false);
                //     this.$scope.contactForm[key].$error['server'] = error;
                // });
                // TODO: figure out a consistent way to map fields to forms.
            }
            console.log('unhandled server error', response.data.errors);
            this.errors = this.getErrors(response.data.errors);
            return;
        }
        
        // fire tracking pixel
        if (response.data.status == 'success' && response.data.pixel) {
            let script = window.document.createElement('script');
            let codeStr = this.cleanPixel(response.data.pixel);
            let code = window.document.createTextNode(codeStr);
            script.appendChild(code);
            window.document.body.appendChild(script);
        }

        
        // reset form data
        this.contactModel = this.contactService.newModel(this.contact);
        this.metaModel = this.metaService.newModel(this.meta);
        this.dataModel = this.dataService.newModel(this.data);

        if (window.jangl && !window.jangl.production) {
            console.log('eval(onSubmit)', this.onSubmit);
        }
        let submission = this.submission;

        eval(this.onSubmit);
        
        // Goto Confirmation page after submit..
        this.step = this.steps.length - 1;
    
    }

    handleCatch(error) {
        this.errors = {
            connection: 'There is an error trying to fetch the server.'
        };
        console.log('Caught unhandled Error', error);
    }

    submit() {
        this.serialize();
        // reset errors on submit.
        this.errors = [];

        // set lead_id_code to jornaya token if available. 
        let lead_id_code = this.leadidService.getToken();
        if (lead_id_code) this.submission.meta.lead_id_code = lead_id_code; 

        // post to backend.
        this.dataService.capture(this.token, this.submission)
            .then(response => this.handleThen(response))
            .catch(errors => this.handleCatch(errors));
    }

    /**
     * @param {Object} invalidInput - object containing data which will override actual form inputs,
     *                                used for testing server side validation from clients.
     */
    submitWithErrors(invalidInput) {
        this.serialize();
        // override with invalid data.
        Object.assign(this.submission, invalidInput);
        // reset errors on submit.
        this.errors = [];
        // post to backend.
        this.dataService.capture(this.token, this.submission)
            .then(response => this.handleThen(response))
            .catch(errors => this.handleCatch(errors));
    }

    log() {
        console.log(this.constructor.name, ...arguments)
    }

    cleanPixel(pixel) {
        return pixel.trim()
                    .replace(/<script(.*?)>/, '')
                    .replace(/<\/script>$/, '');
    }
}



// WEBPACK FOOTER //
// ./app/jangl/BaseFormController.js